var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-password",class:{ 'has-notify': !!_vm.getAuthNotification }},[(!!_vm.getAuthNotification)?_c('AuthNotification'):_vm._e(),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }